<template >
    <el-row class="alltext" :style="{height:all_height}">
      <el-col :offset="2" :span="20">
        <!-- <i class="el-icon-arrow-left" @click="back()" style="cursor: pointer;">返回</i> -->
        <h2 style="text-align: center; margin-bottom: 1.25rem;">发布</h2>
        <el-row >
          <el-col  :span="12" style="text-align: center;">
            主题:<el-input v-model="setup.name_input" placeholder="问卷名称" style="width: 50%;margin-left: 10px;"></el-input>
          </el-col>
          <el-col :span="12" style="text-align: center;">
            时间:
            <el-date-picker
            style="margin-left: 10px;"
              v-model="setup.data"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="time_option"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin-top: 1.25rem;">
          <el-row :style="{height:set_page.first_height}">
            <el-col :offset="1" :span="12" class="first_left" style="background-color: white;">
              <el-row style="margin: 1.25rem;">
                <el-row style="float: right;">
                  <el-button type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
                  <el-button type="success" icon="el-icon-check" circle @click="per_click"></el-button>
                </el-row>
                <el-input  style="margin-top: 9px;" v-model="user_value" placeholder="请输入内容"></el-input> <br />
                <div :style="{height:set_page.tree_height}" class="over_tree">
                  <el-tree
                       show-checkbox
                       :data="info.user_list"
                       ref="treeper"
                       node-key="num"
                       :filter-node-method="filterNode"
                      :props="setup.defaultProps">
                  </el-tree>
                </div>
              </el-row>
            </el-col>
            <el-col :offset="2" :span="8" class="first_left"  style="background-color: white;">
              <el-row style="margin: 1.25rem;">
                <span>您选择的是</span>
                <span style="float: right;">共{{upload.xzper_list.length}}人</span>
                  <el-table
                      :data="upload.xzper_list"
                      style="width: 100%">
                      <el-table-column
                        prop="name"
                        label="姓名">
                      </el-table-column>
                    </el-table>
              </el-row>
            </el-col>
          </el-row>
            <el-button plain style="margin-top: 1.25rem;float: right;" @click="next()">发布</el-button>
        </el-row>
      </el-col>

    </el-row>
</template>

<script>
  export default{
    watch: {
         user_value(val){
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
       },
    data(){
      return{
        time_option: {
          disabledDate(time) {
              return time.getTime() < Date.now() -8.64e7;
          },
        },
        all_height:'',
        user_value:'',
        set_page:{
          active:0,
          tree_height:'',
          type_show:'first',
          first_height:'',
          exam_num_tabClick:true,
          options:[{
             value: '1',
              label: '1'
          },
          {
             value: '2',
              label: '2'
          },

          {
             value: '3',
              label: '3'
          },
          {
             value: '4',
              label: '4'
          },
          {
             value: '5',
              label: '5'
          },]
        },
        info:{
          num:this.$route.query.num,
          user_list:[]
        },
        upload:{
          xzper_list:[],//选择人员
        },
        setup:{
          overdue:false,
          defaultProps: {
            children: 'children',
            label: 'name',
          },
          data:null,
          exam_num:'',
          name_input:'',
        }
      }
    },
    mounted() {
      // this.$message.error(this.info.num);
      this.all_height=window.innerHeight  + 'px'
      this.set_page.first_height=window.innerHeight *0.7  + 'px'
      this.set_page.tree_height=window.innerHeight *0.7 - 150 + 'px'
      this.get_info()
    },
    methods:{
      get_info(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_companyee_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.user_list=res.data.data
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      removeper(){
        let _this=this;
        _this.upload.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
      per_click() {
        let a=this.$refs.treeper.getCheckedNodes();
        this.upload.xzper_list=[];
        let j=0;
        for(let i=0;i<a.length;i++){
          if(a[i].hasOwnProperty('s_id')){
            this.$set(this.upload.xzper_list,j,a[i])
            j++;
          }
        }
        this.upload.xzper_list=this.unique(this.upload.xzper_list)
      },
      unique(arr) {
       const res = new Map();
       return arr.filter((arr) => !res.has(arr.num) && res.set(arr.num, 1));
      },

      next(){
        let _this=this
        if(_this.setup.name_input==''){
          _this.$message.warning('问卷主题不能为空哦')
          return
        }else if(_this.setup.data==null){
          _this.$message.warning('问卷时间不能为空哦')
          return
        }else if(_this.upload.xzper_list.length==0){
          _this.$message.warning('问卷人员不能为空哦')
          return
        }else{
         let data={
           time:_this.setup.data,
           name:_this.setup.name_input,
           companyee:_this.upload.xzper_list,
           num:_this.info.num
         }
         _this.liad_show=true
         _this.axios.post("/v2/c_investigate/investigate_push",{data:data}).then(function (res) {
           if(res.status == "200"){
             if(res.data.code=='1'){
               _this.liad_show=false
               _this.$router.push({path:'/quest_list'})
               _this.$message.success(res.data.msg)
             }else{
               _this.$message.error(res.data.msg)
               _this.liad_show=false
             }
           }else{
             _this.liad_show=false
             _this.$message.error("服务器内部错误")
           }

         })
        }
      },
      up_data(item,i){
        let _this=this

      },
      filterNode(value, data) {
        if (!value) return true;
         return data.name.indexOf(value) !== -1;
           },
    },
  }
</script>

<style scoped>
  .first_left{
    overflow-x: auto;
    border:1px solid 	#9D9D9D;
    border-radius: 5%;
    height: 100%;
    margin-top: 1.25rem;
  }
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
  .alltext{
    background-color: white;
  }
  .right{
     border: 2px solid red;
     border-radius: 5px;
     width: 100%;
  }
  .exam{
    overflow-x: auto;
  }
  .over_tree{
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_list/release.vue